import React from 'react';
import colorVariables from '@densityco/ui/variables/colors.json';
import Chip from '../Chip';

import { Sensor } from '../../types/api';
import { extractOSBuildNumber } from '../../utils/sensor';

const OS_VERSION_COLORS = [
  colorVariables.blueLight,
  colorVariables.redLight,
  colorVariables.greenLight,
  colorVariables.yellowLight,
  colorVariables.purpleLight,
];

const ColoredOSVersion: React.FunctionComponent<{
  short?: boolean,
  osVersion: Sensor['os_version'] | null,
}> = ({short, osVersion}) => {
  if (osVersion === null) {
    return (
      <span>&mdash;</span>
    );
  }

  const osBuildNumber = extractOSBuildNumber(osVersion);

  const color = OS_VERSION_COLORS[osBuildNumber % OS_VERSION_COLORS.length];

  return (
    <Chip size={short ? 'medium' : 'large'} backgroundColor={color} color={colorVariables.gray900}>
      {short ? osBuildNumber : osVersion}
    </Chip>
  );
};

export default ColoredOSVersion;
